import * as z from 'zod'
import { DriverCreateIndividualEntrepreneurEvent } from '~/shared/api'
import { OptionEnum } from '~/shared/config/constants'
import { TaxSystemEnum } from '~/shared/config/enums'

export const formSchema = DriverCreateIndividualEntrepreneurEvent.schema.pick({
  inn: true,
  taxSystem: true,
  email: true,
})

export type SchemaType = z.infer<typeof formSchema>

export type FormValues = Omit<SchemaType, 'taxSystem'> & {
  taxSystem: OptionEnum<TaxSystemEnum> | TaxSystemEnum
}
